import dayjs from "dayjs";

export function calculateWorkDays(begin: dayjs.Dayjs, end: dayjs.Dayjs, publicHolidays: any) {
  const publicHolidaysByDate: string[] = publicHolidays?.map((ph: any) => dayjs(ph.date).format('YYYY-MM-DD')) || []
  
  let d = begin;
  const endValue = end.valueOf();
  let result: number = 0;
  while(d.valueOf() <= endValue) {
    if(d.day() === 6 || d.day() === 0) {
      // do nothing, weekend
    } else if(publicHolidaysByDate.includes(d.format('YYYY-MM-DD'))) {
      // do nothing, public holiday
    } else {
      result++;
    }
    d = d.add(1, 'day')
  }
  return result;
}